// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"8f9c7583","389":"f1d32b9e","861":"f1936452","862":"fce1c9c1","896":"04c4b11c"}[chunkId] + ".chunk.js";
};